import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'si-confirm-action-dialog',
  templateUrl: './confirm-action-dialog.component.html',
  styleUrls: ['./confirm-action-dialog.component.scss']
})
export class ConfirmActionDialogComponent {
  @Input() displayDialog: boolean;
  @Input() dialogClass: string;
  @Input() closable = true;
  @Input() iconClass = 'icon-notification font-color-main1';
  @Input() headerTitleDialog: string;
  @Input() titleDialog: string;
  @Input() subtitleDialog: string;
  @Input() showCancelButton = true;
  @Input() cancelText = 'SI_CANCEL';
  @Input() acceptText = 'SI_ACCEPT';
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() updateChange = new EventEmitter<any>();
  @Output() cancelChange = new EventEmitter<any>();

  constructor() {
  }

  onClickCloseDialog(action: boolean): void {
    if (action) {
      this.updateChange.emit();
    } else {
      this.cancelChange.emit();
    }

    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
  }
}
